'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Thumbnail = require('@narvar/nth-bit-thumbnail');
var mustache = require('mustache');
var placeholderImageUrl = require('./placeholderImageUrl.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Thumbnail__default = /*#__PURE__*/_interopDefaultLegacy(Thumbnail);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);

const renderOptions = {
  escape: x => x
};
const productImageUrlRender = (productInfo, imageUrlTemplate) => {
  // if imageUrlTemplate exists, assume retailer wants an image and
  // back up with a placeholder if itemInfo doesn't have an imageUrl
  return imageUrlTemplate ? mustache__default["default"].render(imageUrlTemplate, productInfo, undefined, renderOptions) || placeholderImageUrl["default"] : productInfo.imageUrl || '';
};
const imageWouldRenderEmpty = (productInfo, imageUrlTemplate) => {
  const imageUrlRenderResult = productImageUrlRender(productInfo, imageUrlTemplate);
  return !imageUrlRenderResult;
};
const ProductThumbnail = ({
  imageUrlTemplate,
  onClick,
  productInfo,
  urlTemplate,
  renderAsLink = true,
  s = {}
}) => {
  // if imageUrlTemplate exists, assume retailer wants an image and
  // back up with a placeholder if itemInfo doesn't have an imageUrl
  const productImageUrl = productImageUrlRender(productInfo, imageUrlTemplate);
  const productUrl = urlTemplate ? mustache__default["default"].render(urlTemplate, productInfo, undefined, renderOptions) : productInfo.url;
  if (!productImageUrl) return null;
  const thumbnail = /*#__PURE__*/React__default["default"].createElement(Thumbnail__default["default"], {
    src: productImageUrl,
    alt: productInfo.name || '',
    s: {
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top center',
      width: '5.5rem',
      verticalAlign: 'top',
      borderRadius: 0,
      ...s
    }
  });
  if (!renderAsLink || !productUrl) return thumbnail;
  return /*#__PURE__*/React__default["default"].createElement("a", {
    href: productUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: onClick
  }, thumbnail);
};

exports["default"] = ProductThumbnail;
exports.imageWouldRenderEmpty = imageWouldRenderEmpty;
